import { instance } from "../config";
import { endpoints } from "../endpoints";
import { SessionChannel } from "../types";
export var getHistory = function getHistory(apiVersion) {
  return instance.post(endpoints.chat.history(apiVersion), {}, {
    params: {
      channel: SessionChannel.App
    }
  });
};